module.exports = __webpack_public_path__ + "static/media/retrato_5.229c9ef2.jpg";